<template>
  <div>
    <app-input-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ClaimRecordForm from "../../../components/claim/claimrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import moment from 'moment';

export default {
  components: {
    "app-input-form": ClaimRecordForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('claimrecordlisting.createnewclaimrecord'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        clmtypeid: null,
        entrytime: null,
       //  clmtypecatid: null,
        claimrecorddetail: [],
         chargeItems: [],
       chargeList: [],
       chargecodes: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

     
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    buttonHandler(){

      this.formData.entrytime = moment(this.entrytime).format('YYYY-MM-DD HH:mm:ss');

     },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/claimrecord/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimrecordlist" });
            this.buttonHandler();
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "claimrecordlist" });
    },
  },
};
</script>